import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabaseConfigured = Boolean(url && anon);

/**
 * Singleton browser Supabase client.
 * Returns null when env vars are missing so the app still boots in demo mode
 * (guest auth, local progress). Real session lands once .env is filled in.
 */
export const supabase = supabaseConfigured
  ? createClient(url, anon, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: "pkce",
      },
    })
  : null;

export function fnUrl(name) {
  if (!url) return null;
  return `${url.replace(/\/$/, "")}/functions/v1/${name}`;
}
